<template>
  <div>
    <Table :columns="columns" :data="tableData"></Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  data() {
    return {
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          fixed: 'left',
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let settlementStatus = params.row.settlementStatus;
            if (settlementStatus == 1) {
              return <span>已结算</span>;
            } else {
              return <span>待结算</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '起保日期',
          align: 'center',
          key: 'startTime',
          minWidth: 130,
          render(h, params) {
            let startTime = params.row.startTime;
            return <span>{filter.filterTime(startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '终保日期',
          align: 'center',
          key: 'endTime',
          minWidth: 130,
          render(h, params) {
            let endTime = params.row.endTime;
            return <span>{filter.filterTime(endTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 150
        },
        {
          title: '费用归属',
          align: 'center',
          key: 'owerName',
          minWidth: 150
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4) {
              return <span>限时活动加费</span>;
            } else if (commissionType == 5 && owerType == 3) {
              return <span>后置费用</span>;
            } else if (commissionType == 5 && owerType == 2) {
              return <span>后置管理费</span>;
            }
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 120
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 120
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 2,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetailWithSelf',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
        this.$emit('showTable', this.total == 0 ? false : true, 2);
      });
    }
  }
};
</script>

<style></style>
